(function () {
  "use strict";

  var campaign = window.SeyoulTonerCampaign = window.SeyoulTonerCampaign || {};
  var cartEvents = [
    "cart:refresh",
    "cart:updated",
    "boosterkit-cart-change",
    "boosterkit-data-updated",
    "boosterkit-line-items-changed",
    "boosterkit-gift-goal-added",
    "boosterkit-free-gift-added"
  ];

  campaign.money = function (cents) {
    try {
      return new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: "THB",
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return "฿" + Math.round(Number(cents || 0) / 100);
    }
  };

  campaign.fetchCart = function () {
    return fetch("/cart.js?t=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json",
        "Cache-Control": "no-cache"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to load cart");
      return response.json();
    });
  };

  campaign.getQikifyOffer = function (root, offerId) {
    if (!root || !window._BK || !Array.isArray(window._BK.entries)) return null;
    offerId = String(offerId || root.dataset.offerId || "");
    return window._BK.entries.find(function (entry) {
      return String(entry.id) === offerId && entry.type === "cart-upsell";
    }) || null;
  };

  campaign.isQikifyOfferEligible = function (root, cart, offerId) {
    var offer = campaign.getQikifyOffer(root, offerId);
    if (!offer || !offer.enable_discount) return false;
    if (!offer.enable_display_conditions) return true;

    var conditions = offer.display_conditions && offer.display_conditions.conditions || [];
    if (!conditions.length) return true;
    var results = conditions.map(function (condition) {
      if (condition.type !== "cart-total") return true;
      var cartTotal = Number(cart && cart.total_price || 0);
      var campaignMinimum = Number(root.dataset.minCartTotal || 0);
      if (campaignMinimum > 0) return cartTotal >= campaignMinimum;
      var required = Math.round(Number(condition.value || 0) * 100);
      if (condition.operator === "greater") return cartTotal > required;
      if (condition.operator === "greater-equal") return cartTotal >= required;
      if (condition.operator === "lower") return cartTotal < required;
      if (condition.operator === "lower-equal") return cartTotal <= required;
      return false;
    });

    return offer.display_conditions.type === "or"
      ? results.some(Boolean)
      : results.every(Boolean);
  };

  campaign.applyDiscountCodes = function (cart, code) {
    var codes = (cart && cart.discount_codes || [])
      .filter(function (discount) { return discount.applicable !== false; })
      .map(function (discount) { return discount.code; })
      .filter(Boolean);
    if (code) codes.push(code);
    codes = Array.from(new Set(codes));
    if (!codes.length) return Promise.resolve();

    var formData = new FormData();
    formData.append("checkout", "");
    return fetch("/cart?discount=" + encodeURIComponent(codes.join(",")), {
      method: "POST",
      credentials: "same-origin",
      body: formData
    }).then(function (response) {
      if (!response.ok) throw new Error("ไม่สามารถใช้ส่วนลด " + code);
      return response.text();
    });
  };

  campaign.delay = function (milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  };

  campaign.waitForQikifyGiftGoal = function (timeout) {
    var startedAt = Date.now();
    var maxWait = Number(timeout || 6000);

    function check() {
      var api = window._BK_API;
      if (!api || typeof api.getGiftGoal !== "function") {
        return campaign.delay(400);
      }
      return Promise.resolve(api.getGiftGoal()).catch(function () {
        return null;
      }).then(function (goal) {
        var timedOut = Date.now() - startedAt >= maxWait;
        if (!goal || !goal.completed || goal.isGiftAdded || timedOut) {
          return campaign.delay(600);
        }
        return campaign.delay(350).then(check);
      });
    }

    return check();
  };

  campaign.addQikifyUpsell = function (variantId, quantity, cart, root, offerConfig) {
    offerConfig = offerConfig || {};
    var offer = campaign.getQikifyOffer(root, offerConfig.offerId);
    var offerId = offerConfig.offerId || offer && offer.id || "";
    var offerType = offerConfig.offerType || offer && offer.type || "cart-upsell";
    var code = offerConfig.code || root.dataset.discountCode || offer && offer.discount_code || "";
    var addRequested = false;
    var expectedQuantity = Number(quantity || 1);

    function getOfferLine(currentCart) {
      return currentCart.items.find(function (item) {
        var itemOfferId = item.properties && item.properties["_qbk-offer-id"];
        return Number(item.variant_id) === Number(variantId) &&
          String(itemOfferId) === String(offerId);
      });
    }

    function offerIsApplied(currentCart) {
      var line = getOfferLine(currentCart);
      if (!line) return false;
      var hasCode = (line.line_level_discount_allocations || []).some(function (allocation) {
        return allocation.discount_application &&
          allocation.discount_application.title === code;
      });
      return hasCode && Number(line.final_price) < Number(line.original_price);
    }

    function ensureOfferDiscount(attempt) {
      return campaign.fetchCart().then(function (currentCart) {
        if (offerIsApplied(currentCart)) return currentCart;
        if (attempt >= 6) {
          throw new Error("ส่วนลด " + code + " ยังไม่ถูกใช้ กรุณาลองอีกครั้ง");
        }
        return campaign.applyDiscountCodes(currentCart, code).then(function () {
          return campaign.delay(500);
        }).then(function () {
          return ensureOfferDiscount(attempt + 1);
        });
      });
    }

    function getTrigger(currentCart) {
      return currentCart.items.find(function (item) {
        var properties = item.properties || {};
        return !properties["_qbk-tier"] &&
          properties["_qbk-offer-type"] !== "free-gift" &&
          String(properties["_qbk-offer-id"] || "") !== String(offerId);
      }) || currentCart.items[0];
    }

    function addOfferLine(currentCart) {
      var trigger = getTrigger(currentCart);
      if (!trigger) return campaign.add(variantId, quantity);
      addRequested = true;
      return fetch("/cart/add.js?qbk-bogo", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: Number(quantity || 1),
            properties: {
              "_qbk-trigger-id": String(trigger.variant_id),
              "_qbk-offer-id": Number(offerId),
              "_qbk-offer-type": offerType,
              "_qbk-discount-code": code
            }
          }]
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.description || "ไม่สามารถเพิ่มสินค้าได้");
          });
        }
        return campaign.applyDiscountCodes(currentCart, code);
      });
    }

    if (!offer) return campaign.add(variantId, quantity);
    window.SeyoulCampaignCartPending = true;

    // Qikify can be updating gift-goal lines immediately after the threshold is reached.
    // Keep the qualifying cart as the trigger source so an unrelated cart read cannot
    // block the paid upsell request behind Qikify's gift-goal queue.
    return campaign.waitForQikifyGiftGoal(6000).then(function () {
      if (!campaign.isQikifyOfferEligible(root, cart, offerId)) {
        return campaign.add(variantId, quantity);
      }
      var existingLine = getOfferLine(cart);
      expectedQuantity += Number(existingLine && existingLine.quantity || 0);
      return addOfferLine(cart);
    }).then(function () {
      return campaign.delay(550);
    }).then(function () {
      return campaign.fetchCart();
    }).then(function (updatedCart) {
      var updatedLine = getOfferLine(updatedCart);
      if (updatedLine && Number(updatedLine.quantity) >= expectedQuantity) return updatedCart;
      return campaign.delay(900).then(function () {
        return campaign.fetchCart();
      }).then(function (latestCart) {
        var latestLine = getOfferLine(latestCart);
        if (latestLine && Number(latestLine.quantity) >= expectedQuantity) {
          return campaign.applyDiscountCodes(latestCart, code);
        }
        return addOfferLine(latestCart).then(function () {
          return campaign.delay(550);
        });
      }).then(function () {
        return campaign.fetchCart();
      });
    }).then(function () {
      return ensureOfferDiscount(0);
    }).then(function (updatedCart) {
      campaign.emitCart(updatedCart);
      updatedCart._tpUpsellApplied = offerIsApplied(updatedCart);
      updatedCart._tpUpsellAdded = addRequested;
      return updatedCart;
    }).finally(function () {
      window.SeyoulCampaignCartPending = false;
    }).then(function (updatedCart) {
      document.dispatchEvent(new CustomEvent("seyoul:mini-cart-open", {
        detail: { cart: updatedCart }
      }));
      return updatedCart;
    });
  };

  function getTonerOfferConfig(node, root) {
    var card = node && node.closest && node.closest("[data-tp-product-card]");
    return {
      offerId: node && node.dataset && node.dataset.tpTonerOfferId ||
        card && card.dataset.tpTonerOfferId ||
        root && root.dataset.offerId ||
        "",
      code: node && node.dataset && node.dataset.tpTonerOfferCode ||
        card && card.dataset.tpTonerOfferCode ||
        root && root.dataset.discountCode ||
        "",
      offerType: node && node.dataset && node.dataset.tpTonerOfferType ||
        card && card.dataset.tpTonerOfferType ||
        "cart-upsell"
    };
  }

  campaign.emitCart = function (cart) {
    document.dispatchEvent(new CustomEvent("seyoul:cart-updated", {
      detail: { cart: cart }
    }));
  };

  campaign.syncMiniCartPrices = function (cart) {
    var items = cart && cart.items || [];
    var cards = Array.from(document.querySelectorAll(".seyoul-mc__item"));
    var usedKeys = {};

    cards.forEach(function (card) {
      var name = card.querySelector(".seyoul-mc__item-name");
      if (!name) return;
      var item = items.find(function (candidate, index) {
        var key = String(candidate.key || index);
        return !usedKeys[key] && candidate.product_title === name.textContent.trim();
      });
      if (!item) return;
      usedKeys[String(item.key || items.indexOf(item))] = true;

      var price = card.querySelector(".seyoul-mc__item-price");
      var compare = card.querySelector(".seyoul-mc__item-compare");
      var finalLinePrice = Number(
        item.final_line_price != null
          ? item.final_line_price
          : Number(item.final_price || 0) * Number(item.quantity || 1)
      );
      var originalLinePrice = Number(
        item.original_line_price != null
          ? item.original_line_price
          : Number(item.original_price || 0) * Number(item.quantity || 1)
      );

      if (price) price.textContent = campaign.money(finalLinePrice);
      if (originalLinePrice > finalLinePrice) {
        if (!compare) {
          compare = document.createElement("span");
          compare.className = "seyoul-mc__item-compare";
          var row = card.querySelector(".seyoul-mc__item-price-row");
          if (row) row.appendChild(compare);
        }
        if (compare) compare.textContent = campaign.money(originalLinePrice);
      } else if (compare) {
        compare.remove();
      }
    });

    var total = document.getElementById("seyoul-mc-total");
    if (total) total.textContent = campaign.money(cart && cart.total_price || 0);
  };

  campaign.refreshCart = function () {
    return campaign.fetchCart().then(function (cart) {
      document.querySelectorAll("[data-tp-cart-count]").forEach(function (node) {
        node.textContent = cart.item_count || 0;
        node.hidden = !cart.item_count;
      });
      document.querySelectorAll("[data-tp-cart-total]").forEach(function (node) {
        node.textContent = campaign.money(cart.total_price);
      });
      campaign.syncMiniCartPrices(cart);
      window.setTimeout(function () { campaign.syncMiniCartPrices(cart); }, 350);
      window.setTimeout(function () { campaign.syncMiniCartPrices(cart); }, 900);
      campaign.emitCart(cart);
      return cart;
    });
  };

  campaign.add = function (variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: Number(quantity || 1) }]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || "ไม่สามารถเพิ่มสินค้าได้");
        });
      }
      return response.json();
    }).then(function () {
      return campaign.refreshCart();
    });
  };

  campaign.goToCheckout = function () {
    var checkoutFallback = function () {
      window.location.assign("/checkout");
    };
    try {
      var form = document.createElement("form");
      var checkoutInput = document.createElement("input");
      form.method = "POST";
      form.action = "/cart";
      form.style.display = "none";
      checkoutInput.type = "hidden";
      checkoutInput.name = "checkout";
      checkoutInput.value = "";
      form.appendChild(checkoutInput);
      document.body.appendChild(form);
      window.setTimeout(checkoutFallback, 900);
      form.submit();
    } catch (error) {
      checkoutFallback();
    }
  };

  function bindSmoothLinks(scope) {
    scope.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.tpScrollBound) return;
      link.dataset.tpScrollBound = "1";
      link.addEventListener("click", function (event) {
        var selector = link.getAttribute("href");
        if (!selector || selector === "#") return;
        var target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
          block: "start"
        });
      });
    });
  }

  function bindCountdowns(scope) {
    scope.querySelectorAll("[data-tp-countdown]").forEach(function (root) {
      if (root.dataset.tpCountdownBound) return;
      root.dataset.tpCountdownBound = "1";
      var end = Date.parse(root.dataset.end || "");
      if (!Number.isFinite(end)) return;

      function tick() {
        var remaining = Math.max(0, end - Date.now());
        var values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor((remaining % 86400000) / 3600000),
          minutes: Math.floor((remaining % 3600000) / 60000),
          seconds: Math.floor((remaining % 60000) / 1000)
        };
        Object.keys(values).forEach(function (key) {
          var node = root.querySelector('[data-unit="' + key + '"]');
          if (node) node.textContent = String(values[key]).padStart(2, "0");
        });
        if (remaining === 0 && root.dataset.endedText) {
          root.setAttribute("aria-label", root.dataset.endedText);
        }
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  function handleProductForm(form) {
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector("[data-tp-atc-status]");
    var variantId = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? clampQuantity(quantityInput) : 1;
    if (!variantId || !variantId.value || !button) return;

    function unlockFormControls() {
      button.disabled = false;
      button.removeAttribute("disabled");
      button.removeAttribute("aria-busy");
      button.removeAttribute("aria-disabled");
      form.querySelectorAll("[data-tp-quantity-button], [name=\"quantity\"]").forEach(function (control) {
        control.disabled = false;
        control.removeAttribute("disabled");
      });
      updateQuantityButtons(form);
    }

    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    form.querySelectorAll("[data-tp-quantity-button], [name=\"quantity\"]").forEach(function (control) {
      control.disabled = true;
    });
    if (status) status.textContent = "กำลังเพิ่มสินค้า…";
    var unlockTimer = window.setTimeout(unlockFormControls, 2200);

    var upsellRoot = form.closest("[data-tp-qikify-upsell]");
    var offerConfig = getTonerOfferConfig(form, upsellRoot);
    var usedUpsell = false;
    campaign.fetchCart().then(function (cart) {
      if (upsellRoot && campaign.isQikifyOfferEligible(upsellRoot, cart, offerConfig.offerId)) {
        usedUpsell = true;
        return campaign.addQikifyUpsell(variantId.value, quantity, cart, upsellRoot, offerConfig);
      }
      return campaign.add(variantId.value, quantity);
    }).then(function (cart) {
      if (status) {
        status.textContent = usedUpsell && !cart._tpUpsellApplied
          ? "เพิ่มแล้ว แต่ส่วนลด " + (offerConfig.code || "TONER") + " ยังไม่ถูกใช้"
          : "เพิ่มลงตะกร้าแล้ว ✓";
      }
      button.textContent = button.dataset.successLabel || "เพิ่มแล้ว ✓";
      window.setTimeout(function () {
        button.textContent = upsellRoot && upsellRoot.classList.contains("is-tp-offer-unlocked")
          ? (upsellRoot.dataset.offerLabel || "ซื้อสิทธิ์ ฿199")
          : (button.dataset.defaultLabel || "หยิบใส่ตะกร้า");
        if (status) status.textContent = "";
      }, 1600);
    }).catch(function (error) {
      if (status) status.textContent = error.message || "เกิดข้อผิดพลาด กรุณาลองใหม่";
    }).finally(function () {
      window.clearTimeout(unlockTimer);
      unlockFormControls();
    });
  }

  function clampQuantity(input) {
    var min = Number(input.min || 1);
    var max = Number(input.max || 99);
    var value = Math.round(Number(input.value || min));
    if (!Number.isFinite(value)) value = min;
    value = Math.min(max, Math.max(min, value));
    input.value = String(value);
    return value;
  }

  function updateQuantityButtons(scope) {
    var roots = scope.matches && scope.matches("[data-tp-quantity]")
      ? [scope]
      : Array.from(scope.querySelectorAll("[data-tp-quantity]"));
    roots.forEach(function (quantityRoot) {
      var input = quantityRoot.querySelector('[name="quantity"]');
      if (!input) return;
      var value = clampQuantity(input);
      var min = Number(input.min || 1);
      var max = Number(input.max || 99);
      var minus = quantityRoot.querySelector('[data-tp-quantity-button="minus"]');
      var plus = quantityRoot.querySelector('[data-tp-quantity-button="plus"]');
      if (minus) minus.disabled = input.disabled || value <= min;
      if (plus) plus.disabled = input.disabled || value >= max;
    });
  }

  function emitQuantityChange(input) {
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest && event.target.closest("[data-tp-quantity-button]");
    if (!trigger) return;
    var quantityRoot = trigger.closest("[data-tp-quantity]");
    var input = quantityRoot && quantityRoot.querySelector('[name="quantity"]');
    if (!input || input.disabled) return;
    event.preventDefault();
    var direction = trigger.dataset.tpQuantityButton;
    var current = clampQuantity(input);
    input.value = String(current + (direction === "plus" ? 1 : -1));
    clampQuantity(input);
    updateQuantityButtons(quantityRoot);
    emitQuantityChange(input);
  });

  document.addEventListener("change", function (event) {
    if (!event.target.matches || !event.target.matches('[data-tp-quantity] [name="quantity"]')) return;
    clampQuantity(event.target);
    updateQuantityButtons(event.target.closest("[data-tp-quantity]"));
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest("[data-tp-product-form]");
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    handleProductForm(form);
  }, true);

  function updateCartGoal(root, cart) {
    var threshold = Number(root.dataset.threshold || 0);
    if (!threshold) return;
    var total = Number(cart && cart.total_price || 0);
    var remaining = Math.max(0, threshold - total);
    var progress = Math.min(100, Math.max(0, total / threshold * 100));
    var bar = root.querySelector("[data-tp-goal-bar]");
    var status = root.querySelector("[data-tp-goal-status]");
    var track = root.querySelector('[role="progressbar"]');

    if (bar) bar.style.width = progress + "%";
    if (track) track.setAttribute("aria-valuenow", String(total));
    root.classList.toggle("is-reached", total >= threshold);

    if (status) {
      status.textContent = total >= threshold
        ? root.dataset.reachedText
        : (root.dataset.progressTemplate || "").replace("[amount]", campaign.money(remaining));
    }
  }

  function bindCartGoals(scope) {
    scope.querySelectorAll("[data-tp-cart-goal]").forEach(function (root) {
      if (root.dataset.tpGoalBound) return;
      root.dataset.tpGoalBound = "1";
      document.addEventListener("seyoul:cart-updated", function (event) {
        if (event.detail && event.detail.cart) updateCartGoal(root, event.detail.cart);
      });
    });
  }

  function popupElementIsVisible(node) {
    if (!node || node.hidden) return false;
    var style = window.getComputedStyle(node);
    if (style.display === "none" || style.visibility === "hidden") return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function popupHasBlockingOverlay(root) {
    var selectors = [
      "#seyoul-mini-cart.is-open",
      "dialog[open]",
      '[role="dialog"][aria-modal="true"]',
      ".qbk-popup-wrapper",
      '[class*="qbk-popup"]',
      '[class*="qbk-modal"]'
    ];
    return Array.from(document.querySelectorAll(selectors.join(","))).some(function (node) {
      return node !== root && !root.contains(node) && popupElementIsVisible(node);
    });
  }

  function closeThresholdPopup(root, dismissed) {
    if (!root) return;
    if (dismissed && root.dataset.tpPopupState) {
      root.dataset.tpPopupDismissedState = root.dataset.tpPopupState;
    }
    root.hidden = true;
    root.classList.remove("is-open");
    document.body.classList.remove("tp-threshold-popup-open");
  }

  function openThresholdPopup(root) {
    if (!root || !root.dataset.tpPopupState) return;
    root.hidden = false;
    root.classList.add("is-open");
    document.body.classList.add("tp-threshold-popup-open");
    var close = root.querySelector(".tp-threshold-popup__close");
    if (close) close.focus({ preventScroll: true });
  }

  function setThresholdPopupContent(root, state, cart) {
    var prefix = state === "unlocked" ? "unlocked" : "locked";
    var threshold = Number(root.dataset.threshold || 0);
    var remaining = Math.max(0, threshold - Number(cart && cart.total_price || 0));
    var replacements = {
      icon: root.dataset[prefix + "Icon"] || (state === "unlocked" ? "✓" : "🎁"),
      eyebrow: root.dataset[prefix + "Eyebrow"] || "",
      heading: root.dataset[prefix + "Heading"] || "",
      text: (root.dataset[prefix + "Text"] || "").replace("[amount]", campaign.money(remaining)),
      button: root.dataset[prefix + "Button"] || ""
    };

    Object.keys(replacements).forEach(function (key) {
      var node = root.querySelector("[data-tp-popup-" + key + "]");
      if (node) node.textContent = replacements[key];
    });
    root.classList.toggle("is-locked", state === "locked");
    root.classList.toggle("is-unlocked", state === "unlocked");
    root.dataset.tpPopupAction = state === "unlocked" ? "products" : "close";
  }

  function updateThresholdPopup(root, cart) {
    root._tpLatestCart = cart;
    var threshold = Number(root.dataset.threshold || 0);
    var editorPreview = root.dataset.designMode === "true"
      ? root.dataset.editorPreview || "auto"
      : "auto";
    var eligible = threshold > 0 && Number(cart && cart.total_price || 0) >= threshold;
    var state = editorPreview === "locked" || editorPreview === "unlocked"
      ? editorPreview
      : (eligible ? "unlocked" : "locked");
    var showLocked = root.dataset.showLocked === "true";
    var storageKey = "tp-toner-threshold-" + threshold + "-" + state;
    var previousState = root.dataset.tpPopupState || "";
    root.dataset.tpPopupState = state;
    root.dataset.tpPopupEligible = eligible ? "true" : "false";
    if (previousState && previousState !== state) {
      root.dataset.tpPopupDismissedState = "";
    }

    if (state === "locked" && !showLocked && editorPreview === "auto") {
      closeThresholdPopup(root, false);
      return;
    }

    setThresholdPopupContent(root, state, cart);
    if (!root.hidden && previousState !== state) closeThresholdPopup(root, false);
    if (root.dataset.tpPopupDismissedState === state) {
      closeThresholdPopup(root, false);
      return;
    }

    if (editorPreview !== "auto") {
      root.dataset.tpPopupPending = "false";
      root.dataset.tpPopupPendingState = "";
      openThresholdPopup(root);
      return;
    }

    var wasShown = false;
    try { wasShown = window.sessionStorage.getItem(storageKey) === "shown"; } catch (error) {}
    if (wasShown || root.dataset.tpPopupPending === "true" || !root.hidden) return;

    root.dataset.tpPopupPending = "true";
    root.dataset.tpPopupPendingState = state;
    var attempts = 0;
    function attemptOpen() {
      if (root.dataset.tpPopupDismissedState === state) {
        root.dataset.tpPopupPending = "false";
        root.dataset.tpPopupPendingState = "";
        return;
      }
      if (root.dataset.tpPopupState !== state) {
        root.dataset.tpPopupPending = "false";
        root.dataset.tpPopupPendingState = "";
        updateThresholdPopup(root, root._tpLatestCart || cart);
        return;
      }
      if (popupHasBlockingOverlay(root) && attempts < 120) {
        attempts += 1;
        window.setTimeout(attemptOpen, 500);
        return;
      }
      root.dataset.tpPopupPending = "false";
      root.dataset.tpPopupPendingState = "";
      try { window.sessionStorage.setItem(storageKey, "shown"); } catch (error) {}
      openThresholdPopup(root);
    }
    window.setTimeout(attemptOpen, state === "locked" ? 1400 : 500);
  }

  function bindThresholdPopups(scope) {
    scope.querySelectorAll("[data-tp-threshold-popup]").forEach(function (root) {
      if (root.dataset.tpPopupBound) return;
      root.dataset.tpPopupBound = "1";
      root.querySelectorAll("[data-tp-popup-close]").forEach(function (button) {
        button.addEventListener("click", function () {
          closeThresholdPopup(root, true);
        });
      });
      var action = root.querySelector("[data-tp-popup-action]");
      if (action) {
        action.addEventListener("click", function () {
          var shouldScroll = root.dataset.tpPopupAction === "products";
          closeThresholdPopup(root, true);
          if (!shouldScroll) return;
          var target = document.getElementById("toner-flash-sale");
          if (!target) return;
          target.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "start"
          });
        });
      }
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !root.hidden) closeThresholdPopup(root, true);
      });
      document.addEventListener("seyoul:cart-updated", function (event) {
        if (event.detail && event.detail.cart) updateThresholdPopup(root, event.detail.cart);
      });
    });
  }

  function updateProductUpsell(root, cart) {
    var hasUnlockedCard = false;

    root.querySelectorAll("[data-tp-product-card]").forEach(function (card) {
      var offerConfig = getTonerOfferConfig(card, root);
      var offer = campaign.getQikifyOffer(root, offerConfig.offerId);
      var eligible = campaign.isQikifyOfferEligible(root, cart, offerConfig.offerId);
      var fixedDiscount = Math.round(Number(offer && offer.discount_value_fixed || 0) * 100);
      var basePrice = Number(card.dataset.basePrice || 0);
      var comparePrice = Number(card.dataset.comparePrice || 0);
      var offerPrice = Math.max(0, basePrice - fixedDiscount);
      var isUnlocked = eligible && fixedDiscount > 0 && offerPrice < basePrice;
      var currentPrice = card.querySelector("[data-tp-current-price]");
      var compare = card.querySelector("[data-tp-compare-price]");
      var note = card.querySelector("[data-tp-offer-note]");
      var button = card.querySelector('button[type="submit"]');

      hasUnlockedCard = hasUnlockedCard || isUnlocked;
      card.classList.toggle("is-tp-offer-unlocked", isUnlocked);
      if (currentPrice) currentPrice.textContent = campaign.money(isUnlocked ? offerPrice : basePrice);
      if (compare) {
        compare.hidden = isUnlocked ? !basePrice : !(comparePrice > basePrice);
        compare.textContent = isUnlocked
          ? campaign.money(basePrice)
          : (comparePrice > basePrice ? campaign.money(comparePrice) : "");
      }
      if (note) {
        note.hidden = !isUnlocked;
        note.textContent = root.dataset.unlockedText || "ปลดล็อกราคา ฿199 แล้ว";
      }
      if (button && !button.disabled && button.getAttribute("aria-busy") !== "true") {
        button.textContent = isUnlocked
          ? (root.dataset.offerLabel || "ซื้อสิทธิ์ ฿199")
          : (button.dataset.defaultLabel || "หยิบใส่ตะกร้า");
      }
    });
    root.classList.toggle("is-tp-offer-unlocked", hasUnlockedCard);
  }

  function bindProductUpsells(scope) {
    scope.querySelectorAll("[data-tp-qikify-upsell]").forEach(function (root) {
      if (root.dataset.tpUpsellBound) return;
      root.dataset.tpUpsellBound = "1";
      document.addEventListener("seyoul:cart-updated", function (event) {
        if (event.detail && event.detail.cart) updateProductUpsell(root, event.detail.cart);
      });
    });
  }

  function bindReviewCarousels(scope) {
    var roots = [];
    if (scope.matches && scope.matches("[data-tp-review-carousel]")) roots.push(scope);
    roots = roots.concat(Array.from(scope.querySelectorAll("[data-tp-review-carousel]")));

    roots.forEach(function (root) {
      if (root.dataset.tpReviewCarouselBound) return;
      root.dataset.tpReviewCarouselBound = "1";

      var track = root.querySelector("[data-tp-review-track]");
      var slides = Array.from(root.querySelectorAll("[data-tp-review-slide]"));
      var dots = Array.from(root.querySelectorAll("[data-tp-review-dot]"));
      var previous = root.querySelector("[data-tp-review-prev]");
      var next = root.querySelector("[data-tp-review-next]");
      var currentIndex = 0;
      var scrollFrame = null;
      if (!track || !slides.length) return;

      function clampIndex(index) {
        return Math.max(0, Math.min(slides.length - 1, Number(index || 0)));
      }

      function updateControls(index) {
        currentIndex = clampIndex(index);
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === currentIndex;
          dot.classList.toggle("is-active", isActive);
          dot.setAttribute("aria-current", isActive ? "true" : "false");
        });
        if (previous) previous.disabled = currentIndex === 0;
        if (next) next.disabled = currentIndex === slides.length - 1;
      }

      function nearestSlideIndex() {
        var trackLeft = track.getBoundingClientRect().left;
        var nearestIndex = 0;
        var nearestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        return nearestIndex;
      }

      function goTo(index, focusTrack) {
        var targetIndex = clampIndex(index);
        var slide = slides[targetIndex];
        var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: reduceMotion ? "auto" : "smooth"
        });
        updateControls(targetIndex);
        if (focusTrack) track.focus({ preventScroll: true });
      }

      root._tpReviewGoTo = goTo;
      updateControls(0);

      track.addEventListener("scroll", function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          updateControls(nearestSlideIndex());
        });
      }, { passive: true });

      track.addEventListener("keydown", function (event) {
        var targetIndex = currentIndex;
        if (event.key === "ArrowLeft") targetIndex -= 1;
        else if (event.key === "ArrowRight") targetIndex += 1;
        else if (event.key === "Home") targetIndex = 0;
        else if (event.key === "End") targetIndex = slides.length - 1;
        else return;
        event.preventDefault();
        goTo(targetIndex, false);
      });

      if (previous) {
        previous.addEventListener("click", function () {
          goTo(currentIndex - 1, false);
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          goTo(currentIndex + 1, false);
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          goTo(Number(dot.dataset.slideIndex || 0), false);
        });
      });
    });
  }

  function bindComboGiftPopups(scope) {
    scope.querySelectorAll("[data-tp-gift-open]").forEach(function (trigger) {
      if (trigger.dataset.tpGiftOpenBound) return;
      trigger.dataset.tpGiftOpenBound = "1";
      trigger.addEventListener("click", function () {
        var popup = document.getElementById(trigger.getAttribute("aria-controls"));
        if (!popup) return;
        popup._tpSourceCard = trigger.closest(".tp-combo-card");
        if (popup.parentElement !== document.body) document.body.appendChild(popup);
        var popupQuantity = popup.querySelector("[data-tp-gift-quantity]");
        var cardQuantity = popup._tpSourceCard && popup._tpSourceCard.querySelector('[data-tp-product-form] [name="quantity"]');
        if (popupQuantity) {
          popupQuantity.value = cardQuantity ? String(clampQuantity(cardQuantity)) : "1";
          updateQuantityButtons(popupQuantity.closest("[data-tp-quantity]"));
        }
        popup.hidden = false;
        popup._tpPreviousFocus = document.activeElement;
        document.body.classList.add("tp-gift-popup-open");
        var focusTarget = popup.querySelector("[data-tp-gift-close], [data-tp-gift-add], button");
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    });

    scope.querySelectorAll("[data-tp-gift-popup]").forEach(function (popup) {
      if (popup.dataset.tpGiftPopupBound) return;
      popup.dataset.tpGiftPopupBound = "1";

      function closePopup() {
        popup.hidden = true;
        document.body.classList.remove("tp-gift-popup-open");
        if (popup._tpPreviousFocus && typeof popup._tpPreviousFocus.focus === "function") {
          popup._tpPreviousFocus.focus({ preventScroll: true });
        }
      }

      function getPopupQuantity(action) {
        var input = popup.querySelector("[data-tp-gift-quantity]");
        if (!input) {
          var card = popup._tpSourceCard || action.closest(".tp-combo-card");
          input = card && card.querySelector('[data-tp-product-form] [name="quantity"]');
        }
        return input ? clampQuantity(input) : 1;
      }

      function setPopupBusy(action, busy) {
        var buttons = popup.querySelectorAll("[data-tp-gift-add], [data-tp-gift-checkout]");
        var quantityControls = popup.querySelectorAll("[data-tp-gift-quantity], .tp-gift-popup__quantity [data-tp-quantity-button]");
        buttons.forEach(function (button) {
          button.disabled = busy;
          button.toggleAttribute("aria-busy", busy);
        });
        quantityControls.forEach(function (control) {
          control.disabled = busy;
        });
        updateQuantityButtons(popup);
        if (!busy) {
          buttons.forEach(function (button) {
            if (button.dataset.defaultLabel) button.textContent = button.dataset.defaultLabel;
          });
        }
      }

      function addGiftProduct(action, checkoutNow) {
        var variantId = action.dataset.variantId;
        var status = popup.querySelector("[data-tp-gift-status]");
        if (!variantId) return;
        setPopupBusy(action, true);
        var quantity = getPopupQuantity(action);
        action.textContent = checkoutNow
          ? (action.dataset.addingLabel || "Adding to cart...")
          : "กำลังเพิ่มสินค้า…";
        if (status) status.textContent = checkoutNow ? "กำลังเพิ่มสินค้าลงตะกร้า..." : "";

        campaign.add(variantId, quantity).then(function () {
          if (checkoutNow) {
            action.textContent = action.dataset.checkoutLabel || "Opening checkout...";
            if (status) status.textContent = "เพิ่มสินค้าแล้ว กำลังเปิดหน้า Checkout...";
            window.setTimeout(function () {
              campaign.goToCheckout();
            }, 220);
            return;
          }
          action.textContent = action.dataset.successLabel || "เพิ่มแล้ว ✓";
          if (status) status.textContent = "เพิ่มลงตะกร้าแล้ว ✓";
          window.setTimeout(function () {
            setPopupBusy(action, false);
            if (status) status.textContent = "";
          }, 1400);
        }).catch(function (error) {
          if (status) status.textContent = error.message || "เกิดข้อผิดพลาด กรุณาลองใหม่";
          setPopupBusy(action, false);
        });
      }

      popup.querySelectorAll("[data-tp-gift-close]").forEach(function (button) {
        button.addEventListener("click", closePopup);
      });

      popup.querySelectorAll("[data-tp-gift-add]").forEach(function (button) {
        button.addEventListener("click", function () {
          addGiftProduct(button, false);
        });
      });

      popup.querySelectorAll("[data-tp-gift-checkout]").forEach(function (button) {
        button.addEventListener("click", function () {
          addGiftProduct(button, true);
        });
      });

      popup.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closePopup();
      });
    });
  }

  campaign.init = function (scope) {
    bindSmoothLinks(scope || document);
    bindCountdowns(scope || document);
    bindCartGoals(scope || document);
    bindThresholdPopups(scope || document);
    bindProductUpsells(scope || document);
    bindReviewCarousels(scope || document);
    bindComboGiftPopups(scope || document);
    updateQuantityButtons(scope || document);
    campaign.refreshCart().catch(function () {});
  };

  document.addEventListener("DOMContentLoaded", function () {
    campaign.init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    campaign.init(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    var slide = event.target.closest && event.target.closest("[data-tp-review-slide]");
    var root = slide && slide.closest("[data-tp-review-carousel]");
    if (!slide || !root || typeof root._tpReviewGoTo !== "function") return;
    root._tpReviewGoTo(Number(slide.dataset.slideIndex || 0), false);
  });

  cartEvents.forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (eventName === "boosterkit-cart-change" && event.detail && event.detail.cart) return;
      window.setTimeout(function () {
        campaign.refreshCart().catch(function () {});
      }, 250);
    });
  });
})();
